import React, { Dispatch, SetStateAction, useState } from "react";
import { LineBoxContainer } from "../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../Button/CalendarLineBtn";
import ConfirmBtn from "../../Button/ConfirmBtn";
import LineBtn from "../../Button/LineBtn";
import FilterIcon from "../../DefaultStyles/FilterIcon";
import Flex from "../../DefaultStyles/Flex";
import DropDown, { OptionType } from "../../Filters/DropDown";
import Search from "../../Filters/Search";
import CalendarModal from "../../Modal/CalendarModal";
import { CalendarLine } from "../Party/ChatInfo/ChatSearch/RecentChat";
import { PartyInfoFilterContainer } from "../Party/PartyInfo/PartyInfoFilter";
import moment from "moment";

interface UserInfoFilterProps {
  setFilter: any;
  dropDownValue: OptionType;
  setDropDownValue: Dispatch<SetStateAction<OptionType>>;
  setSearchValue: Dispatch<SetStateAction<string | undefined>>;
  setPage: Dispatch<SetStateAction<number>>;
  userInfoFilter?: {
    filterType: {
      value: string;
      label: string;
    };
    searchValue: string;
    startDate: string;
    endDate: string;
  };
}

export default function UserInfoFilter({
  setFilter,
  setDropDownValue,
  dropDownValue,
  setSearchValue,
  userInfoFilter,
  setPage,
}: UserInfoFilterProps) {
  const [startDate, setStartDate] = useState(
    userInfoFilter?.startDate !== ""
      ? `${userInfoFilter?.startDate}`
      : "가입일 날짜 선택"
  );
  const [startDateClick, setStartDateClick] = useState(false);
  const [endDate, setEndDate] = useState(
    userInfoFilter?.endDate !== ""
      ? `${userInfoFilter?.endDate}`
      : "가입일 날짜 선택"
  );
  const [endDateClick, setEndDateClick] = useState(false);

  return (
    <PartyInfoFilterContainer>
      <Flex gapSize={10}>
        <DropDown
          isDisabled={false}
          setDropDownValue={setDropDownValue}
          dropdownValue={dropDownValue}
          boxWidth={140}
        />

        <Search
          placeholder="입력"
          setSearchValue={setSearchValue}
          isDisabled={dropDownValue?.value === ""}
          defaultValue={
            userInfoFilter?.searchValue !== ""
              ? userInfoFilter?.searchValue
              : undefined
          }
          pageResetEvent={() => setPage(0)}
          inputType={
            dropDownValue?.value === "phone" || dropDownValue?.value === "uid"
              ? "number"
              : undefined
          }
        />
      </Flex>

      <Flex gapSize={10}>
        <FilterIcon />

        {/* <ToolTip direction="top" msg="한번에 최대 7일까지 조회 가능" /> */}

        <LineBoxContainer>
          <CalendarLineBtn
            onClickEvent={() => setStartDateClick(true)}
            value={startDate}
            initValue={"날짜 선택"}
            minWidth={155}
          />

          {startDateClick && (
            <CalendarModal
              closeEvent={() => setStartDateClick(false)}
              changeEvent={(date: string) => setStartDate(date)}
              isFutureDisable={true}
            />
          )}
        </LineBoxContainer>

        <CalendarLine />

        <LineBoxContainer>
          <CalendarLineBtn
            onClickEvent={() => setEndDateClick(true)}
            value={endDate}
            initValue={"날짜 선택"}
            minWidth={155}
            disabled={startDate === "가입일 날짜 선택"}
          />

          {endDateClick && (
            <CalendarModal
              closeEvent={() => setEndDateClick(false)}
              changeEvent={(date: string) => setEndDate(date)}
              dateValue={startDate}
              isAfterStartDate={true}
            />
          )}
        </LineBoxContainer>

        <LineBtn
          btnText="오늘"
          icon="filter_list"
          btnHeight={38}
          sPadding={"10px 12px 10px 10px"}
          // disabled={disabled}
          btnClickEvent={() => {
            setPage(0);
            setStartDate(moment().format("YYYY-MM-DD"));
            setEndDate(moment().format("YYYY-MM-DD"));
            setFilter({
              startDate: moment().format("YYYY-MM-DD"),
              endDate: moment().format("YYYY-MM-DD"),
            });
          }}
        />

        <ConfirmBtn
          btnText="적용"
          btnColor="mint"
          btnHeight={38}
          btnClickEvent={() => {
            setPage(0);
            setFilter({
              startDate: startDate !== "가입일 날짜 선택" ? startDate : "",
              endDate: endDate !== "가입일 날짜 선택" ? endDate : "",
            });
          }}
          isDisabled={
            startDate === "가입일 날짜 선택" || endDate === "가입일 날짜 선택"
          }
        />

        <LineBtn
          btnText="초기화"
          btnColor="mint"
          icon="refresh"
          btnHeight={38}
          disabled={
            startDate === "가입일 날짜 선택" && endDate === "가입일 날짜 선택"
          }
          btnClickEvent={() => {
            setStartDate("가입일 날짜 선택");
            setEndDate("가입일 날짜 선택");
            setFilter({
              startDate: "",
              endDate: "",
            });
          }}
        />
      </Flex>
    </PartyInfoFilterContainer>
  );
}
